import { PropsWithChildren } from "react";
import { useAuth } from "../../hooks/useAuth";
import { UserRole } from "../../utils/types";

export const TrialScope = ({ children }: PropsWithChildren) => {
  const { roles } = useAuth();

  const isTrial = Array.isArray(roles)
    ? roles.some((role) => role === "TRIAL")
    : (roles as UserRole | null) === "TRIAL";
  if (!isTrial) {
    return null;
  }

  return <>{children}</>;
};
